import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-space-between flex-md-row flex-column" },
      [
        _c(VTextField, {
          staticClass: "ma-5",
          attrs: {
            label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
            type: "date",
            clearable: "",
            rules: [_vm.rules.required],
          },
          model: {
            value: _vm.startDate,
            callback: function ($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate",
          },
        }),
        _c(VTextField, {
          staticClass: "ma-5",
          attrs: {
            label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
            type: "date",
            clearable: "",
            rules: [_vm.rules.dateRange(_vm.startDate, _vm.endDate)],
          },
          model: {
            value: _vm.endDate,
            callback: function ($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(VAutocomplete, {
          staticClass: "ma-5",
          staticStyle: { "z-index": "100" },
          attrs: {
            chips: "",
            clearable: "",
            "deletable-chips": "",
            label: _vm.$vuetify.lang.t("$vuetify.summary.filterInventoryEvent"),
            placeholder: "Leave empty to include all event types",
            multiple: "",
            items: _vm.eventTypes,
            "item-text": "name",
            "item-value": "value",
          },
          model: {
            value: _vm.types,
            callback: function ($$v) {
              _vm.types = $$v
            },
            expression: "types",
          },
        }),
      ],
      1
    ),
    _vm.types.includes("inputs") || _vm.types.includes("outputs")
      ? _c(
          "div",
          [
            _vm.processTypes
              ? _c(VAutocomplete, {
                  staticClass: "ma-5",
                  staticStyle: { "z-index": "100" },
                  attrs: {
                    chips: "",
                    clearable: "",
                    "deletable-chips": "",
                    label: "Manufactoring Process Types",
                    placeholder: "Leave empty to include all process types",
                    multiple: "",
                    items: _vm.processTypes,
                    "item-text": "name",
                    "item-value": "id",
                  },
                  model: {
                    value: _vm.processTypeIds,
                    callback: function ($$v) {
                      _vm.processTypeIds = $$v
                    },
                    expression: "processTypeIds",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.types.includes("sold")
      ? _c(
          "div",
          [
            _vm.customers
              ? _c(VAutocomplete, {
                  staticClass: "ma-5",
                  staticStyle: { "z-index": "100" },
                  attrs: {
                    chips: "",
                    clearable: "",
                    "deletable-chips": "",
                    label: "Customers",
                    placeholder: "Leave empty to include all customers",
                    multiple: "",
                    items: _vm.customers,
                    "item-text": "name",
                    "item-value": "id",
                  },
                  model: {
                    value: _vm.customerIds,
                    callback: function ($$v) {
                      _vm.customerIds = $$v
                    },
                    expression: "customerIds",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.types.includes("purchases")
      ? _c(
          "div",
          [
            _vm.suppliers
              ? _c(VAutocomplete, {
                  staticClass: "ma-5",
                  staticStyle: { "z-index": "100" },
                  attrs: {
                    chips: "",
                    clearable: "",
                    "deletable-chips": "",
                    label: "Suppliers",
                    placeholder: "Leave empty to include all suppliers",
                    multiple: "",
                    items: _vm.suppliers,
                    "item-text": "name",
                    "item-value": "id",
                  },
                  model: {
                    value: _vm.supplierIds,
                    callback: function ($$v) {
                      _vm.supplierIds = $$v
                    },
                    expression: "supplierIds",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }